var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleGrayStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.094,
    height: 13,
    viewBox: "0 0 13.094 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161537",
    "data-name": "Group 161537",
    transform: "translate(-1423.906 -1288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(1424 1288)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 13,
    height: 13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464",
    transform: "translate(0.727 0.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 11.544,
    height: 11.544,
    fill: "none",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M10.979,6l-4.8,4.454L4,8.429",
    transform: "translate(-3.761 -2.436)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleGrayStatus);
export default __webpack_public_path__ + "static/media/Schedule_Gray_status.0591c3742b7bb53db117ce3395aa988d.svg";
export { ForwardRef as ReactComponent };